import { store } from '@/store'

const isCurrentUser = (vue, push) => (vue.$store.state.users && vue.$store.state.users.current && vue.$store.state.users.current.id && push.user && push.user.id && parseInt(push.user.id) === parseInt(vue.$store.state.users.current.id)) 

export default {
    //Добавление груза
    deals_postdealsfreight(data, vue) {
        if (isCurrentUser(vue, data)) return;
        if (vue.$route.name != 'StorekeepersFreights' && vue.$route.name != 'StorekeepersFreight' && vue.$route.name != 'StorekeepersIssueFreight') return;
        const freight = Object.assign({}, data.data);
        if (!freight || !freight.id) return;

        //Обновляем груз в списке грузов
        if (store.state.storekeepers_stocks.freights && store.state.storekeepers_stocks.freights.length)
            store.commit('storekeepers_stocks/unshiftFreight', Object.assign({}, freight));
    },

    //Изменение груза
    deals_putdealsfreight(data, vue) {
        if (isCurrentUser(vue, data)) return;
        if (vue.$route.name != 'StorekeepersFreights' && vue.$route.name != 'StorekeepersFreight' && vue.$route.name != 'StorekeepersIssueFreight') return;
        const freight = Object.assign({}, data.data);
        if (!freight || !freight.id) return;
        //Обновляем груз в списке грузов
        if (store.state.storekeepers_stocks && store.state.storekeepers_stocks.freights) {
            const index = store.state.storekeepers_stocks.freights.findIndex(item => (item && freight && parseInt(item.id) == parseInt(freight.id)))
            if (index >= 0) store.commit('setStateObject', ['storekeepers_stocks.freights.' + index, Object.assign({}, freight)]);
        }
    },

    deals_puttracking(data, vue) {
        if (isCurrentUser(vue, data)) return;
        if (!store.state.storekeepers_stocks || !store.state.storekeepers_stocks.freights || isCurrentUser(vue, data)) return;

        const tracking = Object.assign({}, data.data);
        if (!tracking || !tracking.id) return;

        //Обновляем трекинг в списке грузов
        const index = store.state.storekeepers_stocks.freights.findIndex(item => (item && parseInt(item.id) === parseInt(tracking.freight_id)));
        if (index >= 0 && store.state.storekeepers_stocks.freights[index]) {
            const freight = Object.assign({}, store.state.storekeepers_stocks.freights[index]);
            if (!freight || !freight.id) return;
            freight.currenttracking = Object.assign({}, tracking);
            store.commit('setStateObject', ['storekeepers_stocks.freights.' + index, freight]);
        }

        //Обновляем трекинг в карточке груза
        if (store.state.storekeepers_stocks.freight && tracking.freight_id == store.state.storekeepers_stocks.freight.id)
            store.dispatch('storekeepers_stocks/getFreight', tracking.freight_id);
    },

    //удаление трекинга
    deals_deletetracking(data, vue) {
        if (isCurrentUser(vue, data)) return;

        const tracking = Object.assign({}, data.data);
        if (!tracking || !tracking.id) return;

        //обновляем трекинг в карточке груза
        if (store.state.storekeepers_stocks.freight && tracking.freight_id == store.state.storekeepers_stocks.freight.id)
            store.dispatch('storekeepers_stocks/getFreight', tracking.freight_id);
    },

    deals_postdealsroutelist(data, vue) {
        if (isCurrentUser(vue, data)) return;
        if (vue.$route.name != 'StorekeepersItinerary' && vue.$route.name != 'StorekeepersItineraries') return;

        const RouteList = Object.assign({}, data.data);
        if (!RouteList || !RouteList.id) return;

        if (RouteList && RouteList.freights) RouteList.freights_ids = RouteList.freights.map(freight => parseInt(freight.id));
        if (RouteList.id && store.state.deals.route_lists && parseInt(store.state.deals.currentItinerariesPage) === 1)
            store.commit('deals/unshiftItinerary', RouteList);
        
        if (vue && vue.$root) vue.$root.$emit('update-itinerary-form', RouteList.id);
    },

    deals_putdealsroutelist(data, vue) {
        if (isCurrentUser(vue, data)) return;
        if (vue.$route.name != 'StorekeepersItinerary' && vue.$route.name != 'StorekeepersItineraries') return;

        const RouteList = Object.assign({}, data.data);
        if (!RouteList || !RouteList.id) return;

        RouteList.freights_ids = [];
        if (RouteList && RouteList.freights) RouteList.freights_ids = RouteList.freights.map(freight => parseInt(freight.id));
        if (store.state.deals.route_lists && Array.isArray(store.state.deals.route_lists)) {
          const index = store.state.deals.route_lists.findIndex(item => (parseInt(RouteList.id) == parseInt(item.id)));
          if (index >= 0) store.commit('setStateObject', ['deals.route_lists.' + index, RouteList]);
        }

        if (vue && vue.$root) vue.$root.$emit('update-itinerary-form', RouteList.id);
    },

    deals_deletedealsroutelist(data, vue) {
        if (isCurrentUser(vue, data)) return;
        if (vue.$route.name != 'StorekeepersItinerary' && vue.$route.name != 'StorekeepersItineraries') return;

        const RouteList = Object.assign({}, data.data);
        if (!RouteList || !RouteList.id) return;

        if (store.state.deals.route_lists && Array.isArray(store.state.deals.route_lists)) {
            const index = store.state.deals.route_lists.map(item => (parseInt(item.id) === parseInt(RouteList.id)));
            if (index >= 0) store.commit('deleteStateObject', ['deals.route_lists.' + index]);
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/storekeepers_stocks/pusher.js